// import external dependencies
import 'jquery';
import 'isotope-layout/dist/isotope.pkgd.min';
import 'imagesloaded/imagesloaded.pkgd.min';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'tilt.js/dest/tilt.jquery.min';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleFinalReport from './routes/single-final_report';
import singleActivity from './routes/single-activity';
import singleTrainingSession from './routes/single-training_session';
import singleLecture from './routes/single-activity';  // note that its importing single activity code
import templateFileCabinet from './routes/template-file_cabinet';

import './vert-slider';
import './hero-menu';
import './isotope';
import './downloads-search';
import './questions';
import './gravityforms-layout';
import './header-search';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  singleFinalReport,
  singleActivity,
  singleTrainingSession,
  singleLecture,
  templateFileCabinet,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

if (jQuery('.page-notice').length > 0) {
	setTimeout(() => {
		jQuery('.page-notice').addClass('page-notice-is-visible');
	}, 3000);
}


// WEBPACK FOOTER //
// ./scripts/main.js